import { brand } from '@/lib/branding';

// Wording canonique. Cf. D-UX-MODAL-CANCEL-FERMER.
export const WORDING_CLOSE = 'Fermer';

// Garde partagee cap.ts / transports.ts : action reservee a un chantier en statut en_cours.
export const MSG_CHANTIER_NON_EN_COURS =
  `Action possible uniquement sur un chantier en statut "En cours de traitement". Le chantier doit etre valide par ${brand.name}.`;

// TR-R42 (Lot 14a) : BSDA ICPE dont l'ICPE n'a pas encore cree (ou l'app pas encore importe) le BSDA de reexpedition.
export const MSG_REEXPEDITION_INCONNUE_ADMIN =
  `Le BSDA de réexpédition n'est pas encore connu. L'ICPE doit l'avoir créé en ajoutant ${brand.name} comme courtier.`;
export const MSG_REEXPEDITION_INCONNUE_CLIENT =
  `Le BSDA de réexpédition n'est pas encore disponible. Contactez ${brand.name}.`;

// TR-R43 (Lot 14a) : badge d'un transport dont la suite (transport suivant) est a organiser. Taille propre a chaque ecran.
export const SUITE_A_ORGANISER_LABEL = 'Suite à organiser';
export const SUITE_A_ORGANISER_CLASSES = 'bg-warning-soft text-warning border border-warning-soft-border';

// Hint affiche sous un champ verrouille en mode conversion devis -> commande.
export const MSG_CHAMP_VERROUILLE_CONVERSION =
  "Modification verrouillée. Faites une demande à l'admin après soumission du projet.";

// Journal des emails envoyes (page admin SERME). Mapping action -> libelle FR
// lisible. Consomme via getLabel(EMAIL_ACTION_LABELS, action) : une action non
// mappee retombe sur sa cle brute (aucun risque d'ecran casse).
export const EMAIL_ACTION_LABELS: Record<string, string> = {
  notification_admin_commande_chantier: `Notif ${brand.name} : projet chantier`,
  notification_admin_devis_chantier: `Notif ${brand.name} : demande de devis chantier`,
  notification_admin_commande_transport: `Notif ${brand.name} : commande transport`,
  notification_admin_devis_transport: `Notif ${brand.name} : demande de devis transport`,
  notification_admin_ajout_cap_chantier: `Notif ${brand.name} : ajout Déchet au chantier`,
  notification_admin_nouvelle_demande: `Notif ${brand.name} : nouvelle demande client`,
  notification_admin_anomalie_td: `Notif ${brand.name} : anomalie Trackdechets`,
  confirmation_client_commande_chantier: 'Confirmation client : projet chantier',
  confirmation_client_devis_chantier: 'Confirmation client : demande de devis chantier',
  confirmation_client_commande_transport: 'Confirmation client : commande transport',
  confirmation_client_devis_transport: 'Confirmation client : demande de devis transport',
  confirmation_client_ajout_cap_chantier: 'Confirmation client : ajout Déchet',
  annulation_chantier_email_client: 'Annulation chantier (client)',
  annulation_transport_email_client: 'Annulation transport (client)',
  notification_cap_disponible: 'CAP disponible',
  notification_devis_disponible: 'Devis disponible',
  notification_facture_disponible: 'Facture disponible',
  envoi_facture_client: 'Facture envoyée (PJ)',
  demande_reponse_initiale: 'Réponse à une demande client',
  envoi_rdv_benne_centre: 'RDV benne au centre',
  envoi_rdv_benne_rectificative: 'RDV benne au centre (rectificatif)',
  envoi_confirmation_affretement: 'Confirmation transporteur',
  envoi_confirmation_rectificative: 'Confirmation transporteur (rectificatif)',
  envoi_modification_prix_transporteur: 'Nouveaux prix au transporteur',
  envoi_modification_prix_centre: 'Nouveaux prix au centre',
  notification_transport_planifie: 'Transport planifié (client)',
  envoi_demande_cap: 'Demande de CAP au centre',
  envoi_demande_rectificative_cap: 'Demande de CAP au centre (rectificatif)',
  rappel_pdc_j1: 'Rappel plan de chargement (J-1)',
  rappel_pdc_signature_bsd: 'Rappel plan de chargement (signature BSD)',
  refus_partiel_bsd: 'Refus partiel BSD',
  transport_cloture_sans_traitement: 'Transport clôturé sans traitement',
  health_check_summary: 'Synthèse santé intégrations (DEV)',
  trackdechets_webhook_silence_alert: 'Alerte silence webhook Trackdechets (DEV)',
  trackdechets_webhook_watchdog: 'Webhook Trackdechets réactivé (DEV)',
  trackdechets_webhook_absent: 'Webhook Trackdechets absent (DEV)',
  trackdechets_webhook_reactivation_echec: 'Réactivation webhook Trackdechets en échec (DEV)',
  trackdechets_bsd_introuvables_suspendus: 'Suppressions de BSD suspendues (DEV)',
  trackdechets_rattrapage_echec: 'Recherche des BSD manqués en échec (DEV)',
  pennylane_sync_echec: 'Synchro Pennylane en échec (DEV)',
  rappel_pdc_j1_echec: 'Rappels plan de chargement (J-1) en échec (DEV)',
};

export const EMAIL_STATUT_LABELS: Record<string, string> = {
  envoye: 'Envoyé',
  echoue: 'Échoué',
};

export const EMAIL_STATUT_STYLE: Record<string, string> = {
  envoye: 'bg-green-600 hover:bg-green-700 text-white',
  echoue: 'bg-red-600 hover:bg-red-700 text-white',
};

// Lookup sur un Record<Enum, string> avec une cle `string` generique (typiquement un champ BDD).
// Retourne la valeur associee si la cle est un membre de l'enum, sinon la cle elle-meme (ou '').
export function getLabel<K extends string>(
  record: Record<K, string>,
  key: string | null | undefined,
): string {
  if (!key) return '';
  return (record as Record<string, string>)[key] ?? key;
}

/** Locale FR canonique. Utilisee partout pour `toLocaleDateString`,
 *  `toLocaleTimeString`, `toLocaleString` (dates ET nombres). */
export const LOCALE_FR = 'fr-FR';

export function formatDate(dateStr: string | null | undefined): string {
  if (!dateStr) return '-';
  return new Date(dateStr).toLocaleDateString(LOCALE_FR);
}

export function formatDateTime(dateStr: string | null | undefined): string {
  if (!dateStr) return '-';
  const d = new Date(dateStr);
  const date = d.toLocaleDateString(LOCALE_FR);
  const time = d.toLocaleTimeString(LOCALE_FR, { hour: '2-digit', minute: '2-digit' });
  return `${date} ${time}`;
}

// HH:MM depuis une date/heure complete (ISO/timestamptz). Distinct de formatHm
// (qui tronque une string time PostgreSQL). Pour afficher heure et date sur 2 lignes.
export function formatTime(dateStr: string | null | undefined): string {
  if (!dateStr) return '-';
  return new Date(dateStr).toLocaleTimeString(LOCALE_FR, { hour: '2-digit', minute: '2-digit' });
}

// HH:MM tronque depuis une string time PostgreSQL (`HH:MM:SS` ou plus). Renvoie '-' si vide.
export function formatHm(timeStr: string | null | undefined): string {
  return (timeStr || '-').slice(0, 5);
}

export function toggleArrayItem<T>(arr: T[], item: T): T[] {
  return arr.includes(item) ? arr.filter(i => i !== item) : [...arr, item];
}

// REF-R09 / D-CONTACTS-11 : warning informatif affiche a la modification d'un
// contact (PartnerContactsSection, MesEntreprisesTravauxPage). Centralise pour
// garantir l'unicite du wording en cas d'evolution.
export const CONTACT_MODIFICATION_WARNING =
  "Les nouvelles infos s'appliqueront aux prochains documents (Demande CAP, confirmation, BSD). Les transports déjà envoyés (planifié, traité) conservent les valeurs reçues par le transporteur.";

// Re-exports de compatibilite — contenu deplace lot 4 boilerplate (decontamination
// du socle). Importer depuis les fichiers modules pour le nouveau code.
export * from '@/services/chantiersLabels';
export * from '@/services/capLabels';
export * from '@/services/transportsLabels';
export * from '@/services/demandesLabels';
export * from '@/services/devisFactureLabels';
export * from '@/services/usersLabels';
